import { Injectable, OnInit } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot, NavigationStart } from '@angular/router';
import { AuthService } from './auth.service';
import { LocalStorageService } from '../common/local.storage.service/local.storage.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { map } from 'rxjs/operators';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate, OnInit {

  ngOnInit(): void {
    const returnUrl = this.localStorage.get(AuthService.unauthorizedReturnUrl);
    if (this.authService.isAuthorized === true && returnUrl) {
      this.router.navigate([returnUrl]);
      this.localStorage.remove(AuthService.unauthorizedReturnUrl);
    }
  }
  constructor(
    private authService: AuthService,
    private router: Router,
    private localStorage: LocalStorageService,
    private oidcSecurityService: OidcSecurityService,
  ) {
    this.router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationStart) {
        if (this.authService.user && this.authService.user.mandatory_update && val.url !== '/profile' && val.url !== '/profile/edit') {
          this.router.navigate(['profile/edit']);
        }
        if (this.authService.user && this.authService.user.mandatory_authenticator) {
          window.location.href = '/auth/Manage/TwoFactorAuthentication';
        }
      }
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.oidcSecurityService.getIsAuthorized().pipe(
      map((isAuthorized: boolean) => {
        const hasAccess = this.authService.hasAccessByRoute(route);

        if (isAuthorized && hasAccess) {
          this.localStorage.remove(AuthService.unauthorizedReturnUrl);
          return true;
        }

        if (isAuthorized && !hasAccess) {
          this.router.navigate(['/noaccess']);
          return false;
        }

        this.localStorage.set(AuthService.unauthorizedReturnUrl, state.url);
        this.router.navigate(['/unauthorized']);
        return false;
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authorization.guard.ts